module.exports = __webpack_public_path__ + "static/media/my_info.d0c33763.svg";